import types from './actionTypes'

const initialState = {
  isLogin: false,
  isLoading: false,
  isFailLogin: false,
  loadProfileError: false,
  availableList: [],
  listLoaded: false,
  accessToken: null,
  ssoAccessToken: null,
  loginUser: {},
  app: {},

  isLoadingProfile: false
}

export default function auth(state = initialState, action) {
  switch (action.type) {
    case types.AUTH_LOGIN:
      return {
        ...state,
        isLoading: true,
        isFailLogin: false
      }
    case types.AUTH_FAIL:
      return {
        ...state,
        isLoading: false,
        isFailLogin: true
      }
    case types.AUTH_LEGACY_FAIL:
      return {
        ...state,
        isLoading: false,
        isFailLogin: true
      }
    case types.AUTH_SHOW_AVAILABLE:
      return {
        ...state,
        isLoading: false,
        listLoaded: true,
        availableList: action.data
      }
    case types.AUTH_SELECT_ACCOUNT:
      return {
        ...state,
        ssoAccessToken: action.data.ssoToken,
        accessToken: action.data.account.access_token,
        loginUser: action.data.user,
        app: action.data.account.partner,
        isLogin: true,
        isLoading: false,
        loadProfileError: false
      }
    case types.AUTH_LOGOUT:
      return initialState
    case types.AUTH_LOAD_PROFILE_ERROR:
      return {
        ...state,
        loadProfileError: true
      }

    case types.AUTH_REFRESH_PROFILE:
      return {
        ...state,
        isLoadingProfile: true,
        loadProfileError: false
      }
    
    case types.AUTH_REFRESH_PROFILE_COMPLETE:
      return {
        ...state,
        isLoadingProfile: false,
        loginUser: action.data
      }
    
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Auth/store/reducers.js